import type { ReactNode } from 'react';
import { Flex } from '../../flex';
import { Title } from '../../typography';

export type IconTitleProperties = {
  icon: ReactNode;
  title?: string;
};

const IconTitle = ({ icon, title }: IconTitleProperties) => (
  <Flex align="center" gap="sm">
    {icon}
    {title ? <Title level={5}>{title}</Title> : null}
  </Flex>
);

export default IconTitle;
